import type { FC } from 'react';
import React from 'react';

import { PhoneNumberCheckerForm } from './PhoneNumberCheckerForm';
import { PhoneNumberCheckerLayout } from './PhoneNumberCheckerLayout';

interface Props {
  termsLink?: string;
  containerClassName?: string;

  phoneNumberValidate?(phone: string | number): boolean;
}

export const PhoneNumberChecker: FC<Props> = ({ termsLink, containerClassName, phoneNumberValidate }) => (
  <PhoneNumberCheckerLayout termsLink={termsLink} className={containerClassName}>
    <PhoneNumberCheckerForm phoneNumberValidate={phoneNumberValidate} />
  </PhoneNumberCheckerLayout>
);
